

























































import Vue from "vue";

import IconAlertCircle from "../../assets/icons/transparent/AlertCircle.svg";
import IconTrash from "../../assets/icons/transparent/Trash.svg";
import IconStop from "../../assets/icons/white/Stop.svg";
import IconMicrophone from "../../assets/icons/white/Microphone.svg";
import IconSend from "../../assets/icons/white/Send.svg";
import { MicStatus } from "../../models/microphone";

interface Data {
  icons: {
    alertCircle: string;
  };
  silenceTooltipVisible: boolean;
}

interface Props {
  status: MicStatus;
  disabled: boolean;
  iconTrash: string;
  iconStop: string;
  iconMicrophone: string;
  iconSend: string;
  showSilenceAlert: boolean;
}

export default Vue.extend<Data, {}, {}, Props>({
  name: "JzMicController",

  props: {
    // https://blog.theodo.com/2019/11/integrate-typescript-with-vue/
    status: { type: String as () => MicStatus, required: true },
    disabled: { type: Boolean, default: false },
    iconTrash: { type: String, default: IconTrash },
    iconStop: { type: String, default: IconStop },
    iconMicrophone: { type: String, default: IconMicrophone },
    iconSend: { type: String, default: IconSend },
    showSilenceAlert: { type: Boolean, default: false }
  },

  data() {
    return {
      icons: {
        alertCircle: IconAlertCircle
      },
      silenceTooltipVisible: false
    };
  },

  methods: {
    hideSilenceTooltip() {
      this.silenceTooltipVisible = false;
    },

    showSilenceTooltip() {
      this.silenceTooltipVisible = true;
    }
  }
});
